<template>
    <admin-breadcrumbs>
        <li class="breadcrumb-item">
            <router-link to="/admin/series/">
                Series
            </router-link>
        </li>

        <li class="breadcrumb-item active">
            Edit Lesson
        </li>
    </admin-breadcrumbs>

    <div class="card card-default">

        <div class="card-header">
            Edit Lesson

            <router-link
                :to="`/admin/lessons/${$route.params.id}`"
                class="btn btn-primary btn-sm float-end"
            >
                View Components
            </router-link>

            <router-link
                v-if="lesson.series_id"
                :to="`/admin/series/${lesson.series_id}`"
                class="btn btn-primary btn-sm float-end"
            >
                View Lessons
            </router-link>
        </div>

        <div class="card-body">
            <lesson-edit-form
                :endpoint="`/admin/api/lessons/${$route.params.id}`"
                method="put"
            />
        </div>

    </div>

    <lesson-media-form
        :endpoint="`/admin/api/media/?lesson_id=${$route.params.id}`"
        :lesson-id="$route.params.id"
        method="post"
    />
</template>

<script>
import LessonEditForm from "../../../admin/LessonEditForm.vue";
import LessonMediaForm from "../../../admin/LessonMediaForm.vue";
import AdminBreadcrumbs from "../../../partials/AdminBreadcrumbs.vue";

export default {
    name: "LessonEdit",

    components: {
        AdminBreadcrumbs,
        LessonMediaForm,
        LessonEditForm,
    },

    data() {
        return {
            lesson: {},
        };
    },

    mounted() {
        axios({
            method: "get",
            url: `/admin/api/lessons/${this.$route.params.id}`,
        })
            .then((response) => {
                this.lesson = response.data;
            });
    },
};
</script>
